import React, { useState } from 'react';
import { IoMdClose } from 'react-icons/io';

const FeedbackModal = ({ isOpen, onClose, onSubmit, stepId }) => {
  const [input, setInput] = useState('');

  const handleSubmit = () => {
    onSubmit(stepId, input);
    setInput('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center">
      {/* eslint-disable-next-line */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={onClose}
      />
      <div className="z-10 flex w-96 flex-col rounded-lg bg-zinc-900 text-zinc-100">
        <div className="flex items-center justify-between border-b border-zinc-800 px-4 py-3">
          <h2 className="text-lg font-semibold">Add Feedback</h2>
          <button
            onClick={onClose}
            className="rounded-lg p-1 transition-colors hover:bg-zinc-800"
          >
            <IoMdClose className="h-5 w-5" />
          </button>
        </div>
        <div className="p-4">
          <textarea
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Enter your feedback..."
            className="min-h-32 w-full rounded-md border border-zinc-700 bg-zinc-800 p-3 focus:border-zinc-600 focus:outline-none"
          />
        </div>
        <div className="flex justify-end border-t border-zinc-800 p-4">
          <button
            onClick={handleSubmit}
            className="rounded-md bg-zinc-800 px-4 py-2 text-white transition duration-150 hover:bg-zinc-700"
          >
            Send Feedback
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;
